/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  block-scoped-var,
  global-require,
  import/no-extraneous-dependencies,
  max-len,
  no-redeclare,
  no-var,
  no-void,
  vars-on-top
*/
// import './index.scss';
import React from 'react';
import DarkHeader from 'signer/components/common/dark-header';
import HeaderButton from 'signer/components/common/header-button';
import EsignWrapper from 'signer/components/common/esign-wrapper';
import Logo from 'signer/components/common/logo';
import Image from 'common/components/image';
import * as embeddedActions from 'signer/actions/embedded';
import createReactClass from 'create-react-class';
import { FormattedMessage, FormattedHTMLMessage, defineMessages } from 'react-intl';
import HeaderMenu from 'signer/components/common/header-menu';

const messages = defineMessages({
  getStarted: {
    id: 'signer.preview.getStartedButton.labelText',
    defaultMessage: 'Get Started',
    description: 'Button text in signer flow, when clicked goes to next page to fill input fields and sign',
  },
  poweredBy: {
    id: '',
    defaultMessage: 'POWERED BY{poweredByHelloSignLogo}',
    description: 'text in signer flow, indicating that esign is through HelloSign',
  },
});

/**
 */

const PreviewHeader = createReactClass({

  getDefaultProps() {
    return {
      esignDisclosure: {},
    };
  },

  getStarted() {
    if (this.props.startEnabled) {
      this.props.app.router.redirect('signNext', {
        params: {
          field: this.props.signatureRequest.getNextEditableField(),
        },
      });
    }
  },

  /**
     *
     */

  close() {
    embeddedActions.closeWindow(this.props.app);
  },


  //  ----  RENDERING  ----------------------------------

  renderCompactHeader() {
    const HSLogo = (
      <Logo className='logo' {...this.props} />
    );

    const poweredByHelloSignLogo = (
      <Image src={require('common/images/poweredby_HS.svg')} className='m-signature-request-preview--powered-by-logo' />
    );

    const { intl } = this.props;
    const headerClass = 'm-signature-request-preview--header whitelabel-header compact';
    const buttonContainerClass = 'm-signature-request-preview--get-started-button-container';
    const headerButtonClass = 'm-signature-request-preview--get-started-button whitelabel-primary-button';
    const buttonText = intl.formatMessage(messages.getStarted);
    const esignWrapperContainerClass = 'm-signature-request-preview--esign-wrapper-container';
    const esignWrapperClass = 'm-signature-request-preview--esign-wrapper';

    const esignWrapper = (
      <div className={esignWrapperContainerClass}>
        <EsignWrapper
          className={esignWrapperClass}
          {...this.props}
          checkboxAction={this.props.optIn}
          linkAction={this.props.showEsignDisclosureModal}
          businessName={this.props.esignDisclosure.businessName}
        >
        </EsignWrapper>
      </div>
    );
    const requireEsignOptIn = this.props.esignDisclosure.enabled && !this.props.esignDisclosure.userOptIn;

    return (
      <DarkHeader className={headerClass} {...this.props}>
        <HeaderMenu
          {...this.props}
          canDelegate={this.props.app.canDelegate()} />
        { HSLogo }
        <div className="m-signature-request-preview--right-container">
          { requireEsignOptIn ? esignWrapper : null }
          <div className={buttonContainerClass}>
            <HeaderButton
              className={headerButtonClass}
              onClick={this.getStarted} {...this.props}
              disabled={!this.props.startEnabled}
            >
              { buttonText }
            </HeaderButton>
            <br style={{ clear: 'both' }} />
            { this.props.app.customLogoUri && !this.props.app.hasCustomStyles
              ? <div className='m-signature-request-preview--powered-by'>{ intl.formatMessage(messages.poweredBy, { poweredByHelloSignLogo }) }</div>
              : null }
          </div>
        </div>
      </DarkHeader>
    );
  },

  renderTextHeader() {
    const signatureRequest = this.props.signatureRequest;
    const signer = signatureRequest.signer || {};
    const isMobile = this.props.app.isMobile;
    const isEmbedded = this.props.app.isEmbedded();
    const downloadLink = this.props.signatureRequest.getDownloadLink();
    const { intl } = this.props;

    if (signer.name) {
      var name = `${signer.name} (${signer.emailAddress})`;
    } else {
      var name = signer.emailAddress;
    }
    let headerMessage = (
      <FormattedHTMLMessage
        id="signer.preview.desktopHeaderInfoMessage.siteUi"
        description="text in signature request preview page asking singer to fill out and sing or download the original document"
        defaultMessage="Hello {name},<br />Click 'Get Started' to fill out and sign '<strong>{title}</strong>', or <a href='{downloadLink}'>download</a> the original."
        values={{
          name,
          title: signatureRequest.title,
          downloadLink,
        }} />
    );
    if (isMobile) {
      headerMessage = (
        <FormattedMessage
          id="signer.preview.title"
          description="text in signature request preview page in mobile view asking signer to fill out and sign"
          defaultMessage="Please fill out & sign this document." />
      );
    } else if (isEmbedded) {
      headerMessage = (
        <FormattedHTMLMessage
          id="signer.preview.desktopHeaderInfoMessage.embedded"
          description="text is signature request preview page in embedded flow asking singer to fill out and sign"
          defaultMessage="Hello {name},<br />Click 'Get Started' to fill out and sign '<strong>{title}</strong>'."
          values={{
            name,
            title: signatureRequest.title,
          }} />
      );
    }

    // This will be a custom logo, if there is one. Otherwise, it will be the HS logo.
    const HSLogo = (
      <Logo className='logo' {...this.props} />
    );

    const poweredByHelloSignLogo = (
      <Image src={require('common/images/poweredby_HS.svg')} className='m-signature-request-preview--powered-by-logo' />
    );

    return (
      <DarkHeader
        className='m-signature-request-preview--header whitelabel-header' {...this.props}
      >

        <div className='m-signature-request-preview--info'>
          { HSLogo }
          { this.props.app.canCancel() ? <div data-test-id='preview-close-button' className='m-signature-request-preview--info-close-button' onClick={this.close}>
            <img src={require('./x.png')} />
          </div> : void 0 }
        </div>

        <div className='m-signature-request-preview--subheader'>

          <div className='m-signature-request-preview--header-hello'>
            { headerMessage }
          </div>

          <div className='m-signature-request-preview--get-started-button-container'>
            <HeaderButton className='m-signature-request-preview--get-started-button whitelabel-primary-button' onClick={this.getStarted} {...this.props}>
              { intl.formatMessage(messages.getStarted) }
            </HeaderButton>
            <br style={{ clear: 'both' }} />
            {/* { this.props.app.customLogoUri && !this.props.app.hasCustomStyles ? poweredByHelloSignLogo : null } */}
            { this.props.app.customLogoUri && !this.props.app.hasCustomStyles
              ? <div className='m-signature-request-preview--powered-by'>{ intl.formatMessage(messages.poweredBy, { poweredByHelloSignLogo }) }</div>
              : null }
          </div>
        </div>
      </DarkHeader>
    );
  },

  render() {
    return this.renderCompactHeader();
  },
});

module.exports = PreviewHeader;
